<template>
    <div :key="iteration">
        <loading v-show="isLoading"></loading>
        <form class="selector" enctype="multipart/form-data" @submit.stop.prevent="updateResearchFund($event)">
            <div class="form-group">
                <label for="research-fund">Fund</label>
                <input
                    id="research-fund"
                    v-model="researchFund.name"
                    class="form-control"
                    inputmode="text"
                    name="researchFundName"
                    type="text"
                    required
                >
            </div>
            <div class="form-group">
                <label for="research-fund-manager">Fund Manager</label>
                <input
                    id="research-fund-manager"
                    class="form-control"
                    inputmode="text"
                    name="researchFundManager"
                    type="text"
                    required
                >
            </div>
            <div class="form-group form-group-selectr">
                <label for="type">Type</label>
                <select id="type" class="form-control" name="type" required>
                    <option value="" selected>Please select</option>
                    <option v-for="researchType in researchTypes" :value="researchType.id" v-html="researchType.value"></option>
                </select>
            </div>
            <div class="form-group form-group-selectr">
                <label for="research-benchmark">Benchmark</label>
                <select id="research-benchmark" class="form-control" name="researchBenchmark" required>
                    <option value="" selected>Please select</option>
                    <option v-for="researchBenchmark in researchBenchmarks" :value="researchBenchmark.id" v-html="researchBenchmark.value"></option>
                </select>
            </div>
            <div class="form-group form-group-date">
                <label for="research-start-date">Date Started</label>
                <date-picker
                    id="research-start-date"
                    :is-required="true"
                    :should-emit-event="false"
                    format="dd/MM/yyyy"
                    name="researchStartDate"
                    value=""
                ></date-picker>
            </div>
            <div class="form-group form-group-selectr">
                <label for="research-rating">Rating</label>
                <select id="research-rating" class="form-control" name="researchRating" required>
                    <option value="" selected>Please select</option>
                    <option v-for="researchRating in researchRatings" :value="researchRating.id" v-html="researchRating.value"></option>
                </select>
            </div>
            <div class="form-group">
                <label for="research-notes">Notes (optional)</label>
                <textarea id="research-notes" class="form-control" name="researchNotes"></textarea>
            </div>
            <div class="form-group form-file">
                <label for="research-note-attachment">Attach Research Notes</label>
                <div class="form-group">
                    <input
                        id="research-note-attachment"
                        accept="application/pdf"
                        class="form-control"
                        name="researchNoteAttachment"
                        type="file"
                        required
                    >
                    <p class="tip">Supported file type is<code>.pdf</code></p>
                </div>
            </div>
            <div class="form-group form-file">
                <label for="rfi">RFI (optional)</label>
                <div class="form-group">
                    <input
                        id="rfi"
                        accept="application/pdf"
                        class="form-control"
                        name="rfiAttachment"
                        type="file"
                    >
                    <p class="tip">Supported file type is<code>.pdf</code></p>
                </div>
            </div>
            <div class="form-group form-button">
                <button class="button button-primary" type="submit">Save</button>
            </div>
        </form>
    </div>
</template>

<script>
import Widget from './Widget.vue';
import MargettsApi from '../modules/margetts-api';
import MargettsHelpers from '../modules/helpers';
import loading from "./Loading.vue";

export default {
    extends: Widget,
    components: {
        loading
    },
    props: [
        'default'
    ],

    data() {
        return {
            iteration: 0,
            value: this.default,
            isLoading: true,
            researchNoteAttachmentPath: null,
            rfiAttachmentPath: null,
            researchFund: {},
            researchTypes: {},
            researchBenchmarks: {},
            researchRatings: {},
            uploadedFiles: {},
        }
    },

    created() {
        this.getResearchFund();
    },

    methods: {

        getResearchFund() {
            this.block();
            const parameters = {
                'fund': this.value,
                'user': 'userId'
            };

            MargettsApi.get('external-research/fetch-research-fund', this.createQueryStringFromParameters(parameters, false), response => {
                if (!response || !response.result) {
                    return MargettsApi.throwNoResponseError();
                }
                if (response.result !== 'success') {
                    return this.throwApiError(response.messages);
                }
                const data = response.data;
                this.researchBenchmarks = data.researchBenchmarks;
                this.researchFund = data.researchFund;
                this.researchRatings = data.researchRatings;
                this.researchTypes = data.researchTypes;
                this.unblock();
            }).catch(error => {
                MargettsApi.throwError(error);
            });
        },

        updateResearchFund(event) {
            this.block();
            const parameters = {
                'fund': parseInt(this.researchFund.id),
                'fund_name': event.target.researchFundName.value,
                'fund_manager': event.target.researchFundManager.value,
                'type': event.target.type.value,
                'benchmark': event.target.researchBenchmark.value,
                'date_started': event.target.researchStartDate.value
                    ? MargettsHelpers.formatValue(event.target.researchStartDate.value, 'D/M/Y').toISOString().split('T')[0]
                    : null,
                'rating': parseFloat(event.target.researchRating.value),
                'file_path' : this.researchFund.storage_path,
                'researchNoteAttachment': event.target.researchNoteAttachment.files[0],
                'rfiAttachment': event.target.rfiAttachment.files.length ? event.target.rfiAttachment.files[0] : null,
                'notes': event.target.researchNotes.value,
            };

            if (!this.validateParameters(parameters)) {
                return this.throwValidationError();
            }

            // Check storage path is available and is not null
            if (this.researchFund.storage_path) {
                this.uploadResearchDocuments(parameters).then(response => {
                    return axios.post('/actions/updateResearch', this.buildFormData(response)).then(response => {
                        if (!response || !response.data) {
                            return MargettsApi.throwNoResponseError();
                        }
                        const data = response.data;
                        if (data.success !== true) {
                            throw new Error(data.message);
                        }
                        flash(`${data.message} Redirecting...`, 'success', 200);
                        return window.location = '/actions/updateResearch/success';
                    })
                }).catch(error => {
                    if (error.response) {
                        this.throwApiError(error.response.data.message);
                    } else {
                        this.throwApiError(error.message);
                    }
                });
            }
        },

        async uploadResearchDocuments(parameters) {
            //Check for existing files with the same name and upload research documents
            return await axios.post('/actions/uploadResearchDocuments', this.buildFormData(parameters)).then(response => {
                if (!response || !response.data) {
                    return MargettsApi.throwNoResponseError();
                }
                const data = response.data;
                if (data.success !== true) {
                    throw new Error(data.message);
                }
                parameters.research_notes = data.documents.researchNoteAttachment;
                if(data.documents.rfiAttachment) {
                    parameters.rfi = data.documents.rfiAttachment;
                }
                return parameters;
            });
        },

        buildFormData(parameters) {
            if (typeof parameters !== 'object') {
                return {};
            }
            const formData = new FormData();
            Object.keys(parameters).forEach( paramKey => {
                formData.append(paramKey, parameters[paramKey]);
            });
            return formData;
        },

        isAValidPDFFile(file) {
            return (file && this.uploadIsOfTypes(['application/pdf'], file));
        },

        uploadIsOfTypes(types, file) {
            return types.some(type => type.toLowerCase() === file.type);
        },

        validate(parameters) {
            if (!parameters.date_started || !parameters.date_started.length) {
                this.addValidationMessage('Research Start Date is required.');
            }
        },
    }
}
</script>
